import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://ddiflcjcnuzppyzbbxkr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRkaWZsY2pjbnV6cHB5emJieGtyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTEyMDgzMDIsImV4cCI6MjA2Njc4NDMwMn0.XFBabs-t0qU0MBqcBl7-8wfGv87WCRBV8HwSswkja6E';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
